export { default } from './components/Tabs';
export { default as TabContent } from './components/TabContent';
export { default as TabItem } from './components/TabItem';